import { css, styled } from 'styled-components';

import { BREAKPOINTS } from '@/constants/breakpoints';
import { flexColumn } from '@/styles/common';

export const NoAdsWrapper = styled.div`
  width: 100%;
  ${flexColumn}
  align-items: center;
  gap: 20px;
  color: var(--textAndLabels-main);
  padding: 50px;
`;

export const TextWrapper = styled.div<{ $marginBottom?: string }>`
  ${flexColumn}
  align-items: center;
  gap: 15px;
  text-align: center;

  ${({ $marginBottom }) =>
    !!$marginBottom &&
    css`
      margin-bottom: ${$marginBottom};
    `};
`;

export const IllustrationWrapper = styled.div`
  width: 240px;
  height: auto;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    width: 150px;
  }

  svg {
    width: 100%;
    height: auto;
  }
`;
